import React from "react";

const Card: React.FC<any> = ({ label, icon }) => {
  return (
    <div className="p-10 rounded-lg bg-white shadow-sm border flex items-center justify-center">
      <div className="flex flex-col gap-2 items-center justify-center">
        
        <h3 className="font-poppins font-medium text-3xl text-[#ff700a]">{icon}</h3>
        <h3 className="font-poppins font-medium text-md">{label}</h3>
      </div>
    </div>
  );
};

export default Card;
